import dayjs, { Dayjs } from 'dayjs';
import { SHORT_TIME_FORMAT } from 'consts/timeFormats';

export const parseStringIntoDayjsTime: (time: string) => Dayjs = (time) =>
    dayjs(time, SHORT_TIME_FORMAT);
